import { useEffect, useState } from "react"; // Removed 'React' and 'useRef'
import PropTypes from "prop-types";

// Import MUI Icons
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const CustomHeader = (props) => {
    const { displayName, icon, enableCheckbox, onHeaderCheckboxChanged, column, progressSort, checkStatus } = props;

    const [sortState, setSortState] = useState(null);

    useEffect(() => {
        const onSortChanged = () => {
            if (column.isSortAscending()) {
                setSortState("asc");
            } else if (column.isSortDescending()) {
                setSortState("desc");
            } else {
                setSortState(null);
            }
        };

        column.addEventListener("sortChanged", onSortChanged);
        onSortChanged();

        return () => {
            column.removeEventListener("sortChanged", onSortChanged);
        };
    }, [column]);

    const onSortRequested = (event) => {
        progressSort(event.shiftKey);
    };

    const handleCheckbox = (e) => {
        onHeaderCheckboxChanged?.(e.target.checked);
    };

    return (
        <>
            <div>
                {enableCheckbox && (
                    <input
                        className={checkStatus ? "ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ag-checked" : "ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"}
                        type="checkbox"
                        checked={checkStatus}
                        onChange={handleCheckbox}
                        style={{
                            width: 16,
                            height: 16,
                            cursor: "pointer",
                        }}
                    />
                )}
            </div>
            <div style={{ textAlign: "center", paddingTop: 4, width: "100%" }}>
                {/* Top Row: Checkbox + Product Icon */}

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 8,
                        marginBottom: 6,
                    }}
                >
                    <img
                        src={icon}
                        alt={displayName}
                        style={{ height: 20 }}
                    />
                </div>

                {/* Bottom Row: Label + Sort Icons (Clickable) */}
                <div
                    className="ag-header-cell-label text-xs"
                    onClick={onSortRequested}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 4,
                        cursor: "pointer",
                        userSelect: "none",
                    }}
                >
                    {displayName === "Product Matches Across Workstreams (MatchNet)" ? (
                        <span
                            style={{
                                minWidth: "160px",
                                maxWidth: "160px",
                                textWrap: "auto",
                            }}
                        >{displayName}</span>
                    ) : (   
                        <span>{displayName}</span>
                    )}

                    <div style={{ display: "flex", width: "16px" }}>
                        {sortState === "asc" && <ArrowUpwardIcon sx={{ fontSize: "16px", color: "#666" }} />}
                        {sortState === "desc" && <ArrowDownwardIcon sx={{ fontSize: "16px", color: "#666" }} />}
                    </div>
                </div>
            </div>
        </>
    );
};

CustomHeader.propTypes = {
    displayName: PropTypes.string,
    icon: PropTypes.string,
    enableCheckbox: PropTypes.bool,
    onHeaderCheckboxChanged: PropTypes.func,
    column: PropTypes.object,
    progressSort: PropTypes.func,
    checkStatus: PropTypes.bool,
};

export default CustomHeader;
